import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../utils/axiosConfig';

const ApproveBookingV2 = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const approveBooking = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Invalid token');
        return;
      }

      try {
        console.log('Calling V2 approval endpoint:', `/api/booking-v2/approve/${token}`);
        const response = await axios.get(`/api/booking-v2/approve/${token}`);
        
        console.log('V2 approval response:', response.data);
        
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message || 'V2 Booking approved successfully! Customer has been notified.');
        } else {
          setStatus('error');
          setMessage(response.data.error || 'Unexpected response format');
        }
      } catch (error) {
        console.error('V2 approval error:', error.response?.data || error.message);
        setStatus('error');
        
        if (error.response?.status === 404) {
          setMessage('Booking not found or has already been processed.');
        } else if (error.response?.status === 400) {
          setMessage('This booking has already been approved.');
        } else {
          setMessage(error.response?.data?.error || 'An error occurred while processing the V2 booking');
        }
      }
    };

    approveBooking();
  }, [token]);

  return (
    <div className="approve-booking">
      <h2>V2 Booking Approval</h2>
      {status === 'loading' && <p>Processing your approval...</p>}
      {status === 'success' && (
        <div>
          <p>✅ {message}</p>
          <p>The booking has been successfully approved and the customer will receive a confirmation email.</p>
          <button onClick={() => navigate('/')}>Return to Home</button>
        </div>
      )}
      {status === 'error' && (
        <div>
          <p>❌ Error: {message}</p>
          <button onClick={() => navigate('/')}>Return to Home</button>
        </div>
      )}
    </div>
  );
};

export default ApproveBookingV2;